import * as Sentry from "@sentry/react";
import { type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const fallbackUI = (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Inter, sans-serif",
      background: "#0A1628",
      color: "#fff",
      gap: "16px",
      padding: "32px",
    }}
  >
    <div style={{ fontSize: "40px" }}>⚠️</div>
    <div style={{ fontSize: "20px", fontWeight: 700 }}>Something went wrong</div>
    <div style={{ fontSize: "14px", color: "rgba(255,255,255,0.55)", textAlign: "center", maxWidth: "400px" }}>
      An unexpected error occurred. Our team has been notified. Please reload the page to continue.
    </div>
    <button
      onClick={() => window.location.reload()}
      style={{
        padding: "12px 28px",
        borderRadius: "9px",
        border: "none",
        background: "#F47B20",
        color: "#fff",
        fontWeight: 700,
        fontSize: "14px",
        cursor: "pointer",
        marginTop: "8px",
      }}
    >
      Reload Page
    </button>
  </div>
);

/**
 * Global error boundary that reports crashes to Sentry.
 * Wrap the root <App /> with this so all unhandled React errors
 * are captured before they reach the user.
 */
export function ErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary fallback={fallbackUI} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
